import { useContext } from 'react'

import { useUpdateMediaActionMutation } from '@/common/api/modules/mediaAction'
import { actionStatusChoices } from '@/common/app/modules/media/mediaAction'
import { MediaActionStatus } from '@/common/model/media/mediaAction'

import { MessageType } from '@/components/view/molecules/bar/MessageBar'
import DisclosureSelector from '@/components/view/molecules/selector/DisclosureSelector'

import { ToastMessageContext } from '@/components/container/utils/message/ToastMessageProvider'

interface Props {
  siteId: number
  actionId: number
  status: MediaActionStatus
  // 自動記事作成の実行待ち中は操作できないため変更不可にする
  disabled?: boolean
  // 一覧のテーブルセルでは親幅いっぱい、他の要素と横並びに置く場合は内容幅に収める
  widthFull?: boolean
  onUpdated?(): void | Promise<void>
}

// 推奨アクションのステータス変更セレクタ（一覧行・詳細モーダルで共通利用）。
// 現在のステータスから遷移可能なステータスのみ選択でき、更新後にトーストで通知する。
// 遷移ルールは common/app/modules/media/mediaAction.ts の ACTION_STATUS_TRANSITIONS を参照。
const MediaActionStatusDisclosureSelector = ({
  siteId,
  actionId,
  status,
  disabled,
  widthFull = true,
  onUpdated
}: Props) => {
  const { addMessage } = useContext(ToastMessageContext)

  const { trigger: updateStatus } = useUpdateMediaActionMutation({
    onSuccess: async () => {
      addMessage({ text: 'アクションステータスを更新しました', type: MessageType.SUCCESS })
      await onUpdated?.()
    }
  })

  return (
    <DisclosureSelector
      name={`status-${actionId}`}
      value={status}
      choices={actionStatusChoices(status)}
      disabled={disabled}
      widthFull={widthFull}
      onChange={(next) =>
        updateStatus({ site_id: siteId, action_id: actionId, status: next }).catch(() => undefined)
      }
    />
  )
}

export default MediaActionStatusDisclosureSelector
